import { cardTitle, title } from "assets/jss/material-kit-react.jsx";
import imagesStyle from "assets/jss/material-kit-react/imagesStyles.jsx";
import withDogPhoto from "assets/img/with-dog.jpg";

const featuresStyle = {
  section: {
    padding: "70px 0px",
    textAlign: "center",
    backgroundColor: "#e5e5e5",
    // backgroundImage: `url(${withDogPhoto})`,
    // backgroundSize: "cover",
    // backgroundPosition: "40% 50%",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
      padding: "70px",
    },
    "@media (min-width: 992px)": {
    },
    "@media (min-width: 1200px)": {
    }
  },
  title: {
    ...title,
    color: "black",
    marginBottom: "30px",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  ...imagesStyle,
  itemGrid: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "-66px",
  },
  avatar: {
      marginTop: "10px"
  },
  card: {
    boxSizing: "border-box",
    borderRadius: "0px",
    backgroundColor: "white",
    marginTop: "66px",
    "@media (min-width: 576px)": {
      height: "85%",
    },
    "@media (min-width: 768px)": {
      borderRadius: "6px",
      minHeight: "75%",
      maxHeight: "85%",
    },
    "@media (min-width: 992px)": {
    },
    "@media (min-width: 1200px)": {
    }
  },
  cardTitle: {
    ...cardTitle,
    padding: "0px 30px"
  },
  smallTitle: {
    color: "#6c757d",
    display: "inline-block"
  },
  description: {
    color: "#999"
  },
  justifyCenter: {
    justifyContent: "center !important"
  },
  socials: {
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px",
    color: "#999"
  },
  margin5: {
    margin: "5px"
  },
  cardBody: {
    textAlign: "left"
  },
  cardFooter: {
    paddingTop: "0px",
    paddingBottom: "0px"
  },
  footnote: {
    fontSize: "80%",
    fontStyle: "italic",
    color: "#6c757d",
  },
  inlineBlock: {
    display: "inline-block"
  }
};

export default featuresStyle;